import React from 'react';
import PropTypes from 'prop-types';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';

const DEFAULT_SHARE_IMG = 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg';

const SharePanel = ({ title, desc, img, url }) => {
    const isCategoryPage = window.location.href.includes('/category');
    const search = location.search;
    const shareTitle = title || '';
    const shareImg = img || DEFAULT_SHARE_IMG;
    const shareDesc = desc || '';
    const shareUrl = isCategoryPage ? `https://ishare.ifeng.com/loc/lhqyjhd2026/category${search}` : 'https://ishare.ifeng.com/loc/lhqyjhd2026';

    return (
        <>
            <QQShare
                content={{
                    title: shareTitle,
                    img: shareImg,
                    desc: shareDesc,
                    url: shareUrl,
                    cb: () => {
                        console.log('分享成功');
                    },
                }}
            />
            <div id="ifeng_share_thumbnail" style={{ display: 'none' }}>
                {shareImg}
            </div>
            <div id="ifeng_share_title" style={{ display: 'none' }}>
                {shareTitle}
            </div>
            <div id="ifeng_share_description" style={{ display: 'none' }}>
                {shareDesc}
            </div>
            <div id="ifeng_share_url" style={{ display: 'none' }}>
                {shareUrl}
            </div>
        </>
    );
};

SharePanel.propTypes = {
    title: PropTypes.string,
    desc: PropTypes.string,
    img: PropTypes.string,
    url: PropTypes.string,
};

export default SharePanel;
